import { IconProps } from "typing";
import { theme } from "../themes";

export const MyAccountIcon = ({
  width = "20",
  height = "20",
  color = theme.colors.neutral["999"],
  testId = "my-account-icon",
}: IconProps) => {
  return (
    <svg
      data-testid={testId}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.2612 8.4823C8.91207 9.13317 8.91207 10.1884 8.2612 10.8393C7.61032 11.4902 6.55505 11.4902 5.90417 10.8393C5.2533 10.1884 5.2533 9.13317 5.90417 8.4823C6.55505 7.83142 7.61032 7.83142 8.2612 8.4823"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9.16667H15.8333"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12.0837H12.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99935 15.0345C9.85768 14.6786 9.63852 14.3586 9.35685 14.0978V14.0978C8.88102 13.657 8.25602 13.4111 7.60685 13.4111H6.55852C5.90935 13.4111 5.28435 13.6561 4.80852 14.0978V14.0978C4.52685 14.3578 4.30768 14.6778 4.16602 15.0345"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.832 5.83366H9.16536C8.70536 5.83366 8.33203 5.46033 8.33203 5.00033V2.50033C8.33203 2.04033 8.70536 1.66699 9.16536 1.66699H10.832C11.292 1.66699 11.6654 2.04033 11.6654 2.50033V5.00033C11.6654 5.46033 11.292 5.83366 10.832 5.83366Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33268 4.16699H3.36685C2.42768 4.16699 1.66602 4.92866 1.66602 5.86783V15.8337C1.66602 16.7545 2.41185 17.5003 3.33268 17.5003H16.666C17.5868 17.5003 18.3327 16.7545 18.3327 15.8337V5.83366C18.3327 4.91283 17.5868 4.16699 16.666 4.16699H11.666"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
